import _ from 'lodash'
window._ = _

import jQuery from 'jquery'
window.$ = window.jQuery = jQuery

import { createPopper } from '@popperjs/core'
import 'bootstrap'
import 'datatables.net-bs5'
import 'datatables.net-buttons-bs5'
// import 'datatables.net-select-bs5'
// import 'datatables.net-searchpanes-bs5'

import axios from 'axios'
window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

import moment from 'moment'
window.moment = moment